import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBubble6"><Path d="M7.5 3C4.46243 3 2 5.46243 2 8.5V20.5C2 20.7761 2.22386 21 2.5 21H16.5C19.5376 21 22 18.5376 22 15.5V8.5C22 5.46243 19.5376 3 16.5 3H7.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble6;
